import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { usePermissions } from '../context/PermissionContext';
import { getMenuIdFromPath } from '../config/menuConfig';
import { FiAlertCircle, FiHome } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const RequireMenuPermission = ({ children }) => {
  const location = useLocation();
  const { isAdmin, hasPermission, loading, hasPermissionsConfigured } = usePermissions();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (isAdmin) {
    return children;
  }

  const menuId = getMenuIdFromPath(location.pathname);

  if (!menuId) {
    return children;
  }

  if (!hasPermissionsConfigured) {
    return children;
  }

  if (!hasPermission(menuId, 'view')) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
            <FiAlertCircle size={32} className="text-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
          <p className="text-gray-600 mb-6">
            You don't have permission to access this page. Please contact your institute administrator if you believe this is an error.
          </p>
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <FiHome />
            Go to Dashboard
          </Link>
        </div>
      </div>
    );
  }

  return children;
};

export default RequireMenuPermission;
